<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.teacherDeletedList.push"
    :query-list="queryList"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
  >
    <el-table-column width="70px" label="ID" prop="id"/>

    <v-column-time/>

    <v-column-admin v-if="isAdministrator" label="添加者"/>

    <v-column-avatar :link-page-name="RouteConfig.teacherDetail.name"/>

    <el-table-column label="所属门店" prop="store_names"/>

    <el-table-column label="手机号" prop="phone"/>

    <el-table-column label="企业微信号" prop="we_chat"/>

    <el-table-column label="微博号" prop="micro_blog"/>

    <el-table-column label="美拍号" prop="mei_pai"/>

    <el-table-column label="操作" :width="isAdministrator ? '410px' : '310px'">
      <template v-slot="{ row }">
        <v-list-button name="修改资料" size="large" :to="RouteConfig.teacherEdit.to(row.id)"/>

        <v-popover>
          <v-popover-item
            v-if="isAdministrator"
            name="还原老师"
            icon="restore"
            @click="handleDelete(row.id)"
            :is-loading="isDeleting[row.id]"
            message="确认要还原该老师吗？"
          />
          <v-popover-item icon="mini-app-qr-code" name="小程序码" @click="getQrCode(row.id)" :is-loading="isGetting[row.id]"/>
        </v-popover>

      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`teacher-deleted-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div v-if="isAdministrator" class="list-item-detail">
              <span>添加者</span>
              <v-avatar-nickname
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>老师</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :link-page-name="RouteConfig.teacherDetail.name"
                :link-page-id="v.id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_names }}</span>
            </div>
            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>
            <div class="list-item-detail">
              <span>企业微信号</span>
              <span>{{ v.we_chat }}</span>
            </div>
            <div class="list-item-detail">
              <span>微博号</span>
              <span>{{ v.micro_blog }}</span>
            </div>
            <div class="list-item-detail">
              <span>美拍号</span>
              <span>{{ v.mei_pai }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button name="修改资料" size="large" :to="RouteConfig.teacherEdit.to(v.id)"/>
              <v-popover>
                <v-popover-item
                  v-if="isAdministrator"
                  name="还原老师"
                  icon="restore"
                  @click="handleDelete(v.id)"
                  :is-loading="isDeleting[v.id]"
                  message="确认要还原该老师吗？"
                />
                <v-popover-item icon="mini-app-qr-code" name="小程序码" @click="getQrCode(v.id)" :is-loading="isGetting[v.id]"/>
              </v-popover>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, restore, getQrCode } from '@/api/teacher';
// import { store as saveTeacherFromStore, destroyByTeacherId } from '@/api/store-teacher';
import { getLegalQueryList } from '@/utils/formats';

export default {
  name: RouteConfig.teacherDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isSaving: {},
    isDeleting: {},
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    count: 0,
    list: [],
    isGetting: [],
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'isManager',
      'isReceptionist',
      'isManagerOrReceptionist',
      'defaultStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.teacherList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, route.query);

      const { ...params } = queryList;
      params.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;

      if (next) next();
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
    async handleDelete(id) {
      if (!id) return;
      this.$set(this.isDeleting, id, true);
      const { isError } = await restore(id);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
    async getQrCode(id, obj) {
      if (this.isGetting[id]) return;

      this.$set(this.isGetting, id, true);
      const { isError, data } = await getQrCode(id);
      this.$set(this.isGetting, id, false);
      if (isError) return;

      if (!data.qr_code) return;
      if (!obj) return window.open(data.qr_code);
      Object.assign(obj, { src: data.qr_code });
    },
  },
};
</script>
